
import React from 'react';
import ArticleCard, { Article } from './ArticleCard';
import ArticleCardSkeleton from './ArticleCardSkeleton';

interface ArticleListProps {
  articles: Article[];
  isLoading: boolean;
}

const ArticleList = ({ articles, isLoading }: ArticleListProps) => {
  if (isLoading) {
    return (
      <div className="space-y-4">
        {[1, 2, 3].map((i) => (
          <ArticleCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {articles.map((article) => (
        <ArticleCard key={article.id} article={article} />
      ))}
    </div>
  );
};

export default ArticleList;
